import { render, staticRenderFns } from "./Capsulas Blandas.vue?vue&type=template&id=64c6fb13&scoped=true&lang=pug&"
var script = {}
import style0 from "./Capsulas Blandas.vue?vue&type=style&index=0&id=64c6fb13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6fb13",
  null
  
)

export default component.exports